!function (t, o) {
  "object" == typeof exports && "object" == typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define([], o) : "object" == typeof exports ? exports.identityImg = o() : t.identityImg = o();
}(this, function () {
  return function (t) {
    var o = {};

    function e(n) {
      if (o[n]) return o[n].exports;
      var i = o[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }

    return e.m = t, e.c = o, e.d = function (t, o, n) {
      e.o(t, o) || Object.defineProperty(t, o, {
        enumerable: !0,
        get: n
      });
    }, e.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, o) {
      if (1 & o && (t = e(t)), 8 & o) return t;
      if (4 & o && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (e.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & o && "string" != typeof t) for (var i in t) {
        e.d(n, i, function (o) {
          return t[o];
        }.bind(null, i));
      }
      return n;
    }, e.n = function (t) {
      var o = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(o, "a", o), o;
    }, e.o = function (t, o) {
      return Object.prototype.hasOwnProperty.call(t, o);
    }, e.p = "", e(e.s = 0);
  }([function (t, o, e) {
    "use strict";

    var n = this && this.__assign || function () {
      return (n = Object.assign || function (t) {
        for (var o, e = 1, n = arguments.length; e < n; e++) {
          for (var i in o = arguments[e]) {
            Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(o, "__esModule", {
      value: !0
    });

    var i = function () {
      function t(o, e) {
        (e = n(n({}, t.defaultOptions), e || {})).randomColor && (e.bgColor = t.hashToColor(o, e.bgStep, e.bgLen), e.mainColor = t.hashToColor(o, e.mainStep, e.mainLen), e.nanColor = t.hashToColor(o, e.nanLen, e.nanStep)), this.hash = o, this.options = e, this.canvas = document.createElement("CANVAS"), this.ctx = this.canvas.getContext("2d"), this.canvas.width = this.options.size, this.canvas.height = this.options.size, this.hashMatrix = [], this._fillMatrix(o);
      }

      return t.prototype.getImage = function () {
        for (var t = this.options.size / this.options.cells, o = this.options.size / this.options.rows, e = 0; e < this.options.rows; e++) {
          for (var n = 0; n < this.options.cells; n++) {
            this._addCell(n, e, t, o);
          }
        }

        return this.canvas.toDataURL("image/png");
      }, t.prototype._addCell = function (t, o, e, n) {
        var i = this._getColors(t, o);

        i || this._addRect(t, o, e, n, this.options.bgColor), this._addRect(t, o, e, n, i);
      }, t.prototype._addRect = function (t, o, e, n, i) {
        this.ctx.fillStyle = i, this.ctx.beginPath(), this.ctx.rect(t * e - .5, o * n - .5, e + .5, n + .5), this.ctx.fill(), this.ctx.closePath();
      }, t.prototype._getColors = function (t, o) {
        return t < this.options.cells / 2 ? isNaN(this.hashMatrix[t][o]) ? this.options.nanColor : this.hashMatrix[t][o] % 2 ? this.options.mainColor : null : this._getColors(this.options.cells - 1 - t, o);
      }, t.prototype._fillMatrix = function (t) {
        for (var o = 0, e = 0; e < this.options.cells; e++) {
          this.hashMatrix[e] = [];

          for (var n = 0; n < this.options.rows; n++) {
            null == this.hash[o] && (this.hash += t), this.hashMatrix[e][n] = parseInt(this.hash[o], 30), o++;
          }
        }
      }, t.hashToColor = function (t, o, e) {
        for (var n = [], i = 0; i < 3; i++) {
          n.push(t.slice(Math.round(-7 / e - 3 * e - o * i), t.length - o * i));
        }

        return "rgb(" + n.map(function (t) {
          var o = t.split(""),
              n = [];

          do {
            n.push(o.splice(0, e));
          } while (o.length);

          return n.reduce(function (t, o) {
            return Math.min(t + parseInt(o, 36), 255);
          }, 0);
        }).join() + ")";
      }, t.defaultOptions = {
        size: 90,
        bgColor: "#bfbfbf",
        nanColor: "#EFB66C",
        mainColor: "#1C3D29",
        rows: 9,
        cells: 9,
        randomColor: !0,
        mainStep: 4,
        nanStep: 5,
        mainLen: 1.5,
        nanLen: 3,
        bgStep: 3,
        bgLen: 4
      }, t;
    }();

    o.config = function (t) {
      i.defaultOptions = n(n({}, i.defaultOptions), t);
    }, o.create = function (t, o) {
      return new i(t, o).getImage();
    };
  }]);
});